import { css } from '@linaria/core';
import { textRegular } from 'styles/typography';
import { baseUnits, theming } from 'styles/utils';
export const popoverDiv = "omponents__InputInfoPopover__styles_ts-popoverDiv-p9n8p77";
export const listItem = "omponents__InputInfoPopover__styles_ts-listItem-l1qzgv67";
export const metaDataCss = "omponents__InputInfoPopover__styles_ts-metaDataCss-m1cgpmcx";
export const title = `${"omponents__InputInfoPopover__styles_ts-title-tdmnag0"}

  ${textRegular}
`;
export const dataValue = "omponents__InputInfoPopover__styles_ts-dataValue-djg4r17";
export const closeIcon = "omponents__InputInfoPopover__styles_ts-closeIcon-c1gg5rc1";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");